import React, { useState } from "react";
import { Button, Space, Form, Spin } from "antd";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { COLORS, FullSpan } from "../../../constants";
import Notification from "../../../components/shared/Notification";
import {
  formatMonthYear,
  formatYear,
  formatMonth,
} from "../../../helpers/formatDate";
import {
  getMonthlyReport,
  getNationalReport,
} from "~v2/http-request/mice-report";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import GenerateReportForm from "../../components/GenerateReportForm/GenerateReportForm";

const MICEreportAdminPage = () => {
  const [forms] = Form.useForm();
  const [isLoadingDownloadReport, setisLoadingDownloadReport] = useState(false);
  const [establishmentDetails, setestablishmentDetails] = useState();
  const navigate = useNavigate();

  const handleChange = (value) => {
    setestablishmentDetails(value);
  };

  const downloadReports = async (values) => {
    setisLoadingDownloadReport(true);
    if (!values) {
      Notification(
        "Error",
        "Please select a date and an establishment to download national report!",
        "error"
      );

      setisLoadingDownloadReport(false);
      return forms.resetFields();
    }
    values.date = formatMonthYear(values.month, values.year);
    values.establishmentId = values.establishment.value;
    let token = localStorage.getItem("token");

    await getMonthlyReport(values, token).then((res) => {
      if (res?.downloadLink) {
        window.open(res.downloadLink, "_blank");
      }
    });

    await getNationalReport(values.date, token)
      .then((res) => {
        if (res?.downloadLink) {
          window.open(res.downloadLink, "_blank");
        }
      })
      .finally(() => {
        setisLoadingDownloadReport(false);
      });
  };

  const viewDayReport = () => {
    let { month, year } = forms.getFieldsValue(["month", "year"]);
    month = formatMonth(month);
    year = formatYear(year);
    if (!month || !year || !establishmentDetails) {
      Notification(
        "Error",
        "Please select a date and an establishment!",
        "error"
      );
      return;
    }
    navigate(`./report/${establishmentDetails.value}`, {
      state: { month, year, establishment: establishmentDetails.label },
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.white }} spin />
  );

  return (
    <AppContainer title="MICE Report">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <Form
            {...FullSpan}
            form={forms}
            initialValues={{
              year: moment(),
              month: moment(),
            }}
            onFinish={downloadReports}
          >
            <GenerateReportForm handleChange={handleChange} />
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Button block type="primary" onClick={viewDayReport}>
                Generate
              </Button>
              <Button
                style={{ backgroundColor: COLORS.orange, border: 0 }}
                block
                type="primary"
                htmlType="submit"
              >
                {isLoadingDownloadReport ? (
                  <Spin indicator={antIcon} />
                ) : (
                  "Download All Report"
                )}
              </Button>
            </Space>
          </Form>
        </div>
      </center>
    </AppContainer>
  );
};

export default MICEreportAdminPage;
